<template lang="pug">
  .form
    .form__elem
      .form-elem
        .form-elem__body
          .achievements
            .achievements__list.achievements-list
              .achievements-list__item(
                v-for="item in fields"
              )
                .achievement
                  .attached-file
                    .button
                      .button__text(
                        @click="onClickPorfolio(item)"
                      ) {{ item.name }}
                      .attached-file__checkbox
                        label.checkbox(
                          v-if="status === 2"
                        )
                          input.checkbox__input(
                            type="checkbox"
                            :checked="item.checked"
                            @change="onClickCheckbox($event, item)"
                          )
                          .checkbox__icon
    .form__elem
      .form-elem
        .form-elem__title Количество баллов
        .form-elem__body
          .points {{ status === 2 ? this.currentAwardsPoints : getPoints(this.fields) }}
</template>
<script>
export default {
  name: "Awards",
  props: [
    "fields",
    "onClickPorfolio",
    "status",
    "onClickCheckbox",
    "currentAwardsPoints"
  ],
  methods: {
    getPoints(list) {
      var points = 0;
      for (var i = 0; i < list.length; i++) {
        if (list[i].is_approved) {
          points += list[i].points;
        }
      }
      return points;
    }
  }
};
</script>
